<template>
  <div class="control-wrapper">
    <button @click="toggleMenu" class="toggle-button">
      {{ isMenuVisible ? '隱藏' : '顯示' }}
    </button>
    
    <section class="control-container" :class="{ 'menu-visible': isMenuVisible }">
    <h3 class="control-header">收據管理</h3>

    <section class="item-container">
      <section
        class="control-item"
        v-for="(control, key) in controls"
        :key="key"
      >
        <section class="control">
          <span class="item-label">
            {{ control.label }}
          </span>

          <div class="flex-1" v-if="control.inputType === 'date'">
            <flat-pickr
              v-model="controlValue[control.vModel]"
              class="form-control"
              :config="{
                allowInput: true,
                altInput: true,
                altFormat: 'Y-m-d',
                dateFormat: 'Y-m-d',
              }"
            />
          </div>
          <div class="flex-1" v-else>
            <input
              :class="
                control.inputType === 'checkbox'
                  ? 'input-checkbox'
                  : 'input-box'
              "
              :type="control.inputType"
              :value="controlValue[control.vModel]"
              :checked="controlValue[control.vModel]"
              @input="setInput($event, control.vModel, control.inputType)"
              @change="setInput($event, control.vModel, control.inputType)"
            />
          </div>
        </section>

        <section class="options-container">
          <section class="options-item">
            <span class="options-title"> Type: </span>

            <span class="options-value">
              {{ control.type }}
            </span>
          </section>

          <section class="options-item">
            <span class="options-title"> Options: </span>

            <span class="options-value">
              {{ control.options }}
            </span>
          </section>
        </section>

        <section v-if="control.label === 'manual-pagination:'">
          <b>Note:</b> <br />
          When enabling this prop, the prop <br />
          <b> paginate-elements-by-height </b> will not be used. Instead the
          pagination process will rely on the elements with a class
          "html2pdf__page-break" to know where to page break.
        </section>
      </section>
      <!--
            <div>
                <b>Note:</b> <br> There is a prop called <b>html-to-pdf-options</b>, if you set a value to
                this prop, the props below will be overridden: <br><br>
                <b>filename</b><br>
                <b>pdf-quality</b><br>
                <b>pdf-format</b><br>
                <b>pdf-orientation</b>.<br><br>
                Any value inputed to those props above will have no effect.
            </div>
            -->
    </section>

    <b-button
      :disabled="isGenerating"
      class="generate-btn"
      style="margin-bottom: 10px"
      :to="{ name: 'refunds-list' }"
      v-if="ability.can('read', 'refunds')"
    >
    退款列表
    </b-button>
    <b-button
      :disabled="isGenerating"
      class="generate-btn"
      style="margin-bottom: 10px"
      :to="{ name: 'refund-edit', params: { id: refundData.id } }"
      v-if="ability.can('update', 'refunds')"
    >
      修改退款
    </b-button>
    <button
      :disabled="isGenerating"
      class="generate-btn"
      @click="$emit('generateReport')"
    >
      {{ isGenerating ? "Loading..." : "列印退款" }}
    </button>

    <section class="progress-container">
      <div class="progress-bar">
        <div class="progress" :style="`width: ${progress}%;`" />
      </div>

      <section class="generating-label" v-if="progress !== 0">
        <span class="label-title">
          {{ progress === 100 ? "列印退款完成" : "列印退款中" }}
        </span>

        <span class="label-progress">
          {{ `${progress} %` }}
        </span>
      </section>
    </section>
    </section>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import store from "@/store";
import flatPickr from "vue-flatpickr-component";
import { BButton } from "bootstrap-vue";
import ability from "@/libs/acl/ability";
import { sanitizeFilename } from "@core/utils/filter";

export default {
  components: {
    BButton,
    flatPickr,
  },
  props: {
    progress: {
      type: Number,
      default: 0,
    },
    refundData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ability,
      controls: [
        // {
        // 	label: 'show-layout:',
        // 	type: 'Boolean',
        //     options: 'true, false',
        //     inputType: 'checkbox',
        //     vModel: 'showLayout'
        // },

        // {
        // 	label: 'float-layout:',
        // 	type: 'Boolean',
        //     options: 'true, false',
        //     inputType: 'checkbox',
        //     vModel: 'floatLayout'
        // },

        // {
        // 	label: 'enable-download:',
        // 	type: 'Boolean',
        //     options: 'true, false',
        //     inputType: 'checkbox',
        //     vModel: 'enableDownload'
        // },

        // {
        // 	label: 'preview-modal:',
        // 	type: 'Boolean',
        //     options: 'true, false',
        //     inputType: 'checkbox',
        //     vModel: 'previewModal'
        // },

        // {
        // 	label: 'manual-pagination:',
        // 	type: 'Boolean',
        //     options: 'true, false',
        //     inputType: 'checkbox',
        //     vModel: 'manualPagination'
        // },

        // {
        // 	label: 'paginate-elements-by-height:',
        // 	type: 'Number',
        //     options: 'Any Number',
        //     inputType: 'number',
        //     vModel: 'paginateElementsByHeight'
        // },

        {
          label: "檔案名稱:",
          type: "String",
          options: "Any String",
          inputType: "text",
          vModel: "filename",
        },

        {
          label: "簽署日期:",
          type: "Date",
          options: "Any Date",
          inputType: "date",
          vModel: "sign_date",
        },

        // {
        // 	label: 'pdf-quality:',
        // 	type: 'Number',
        //     options: '0 - 2 (Can Have Decimal)',
        //     inputType: 'number',
        //     vModel: 'pdfQuality'
        // },
        // {
        //   label: "Table 高度(cm):",
        //   type: "Number",
        //   options: "Any Number",
        //   inputType: "number",
        //   vModel: "minHeight",
        // },
        // {
        // 	label: 'pdf-format:',
        // 	type: 'String',
        //     options: 'a0, a1, a2, a3, a4, letter, legal, a5, a6, a7, a8, a9, a10',
        //     inputType: 'text',
        //     vModel: 'pdfFormat'
        // },

        // {
        // 	label: 'pdf-orientation:',
        // 	type: 'String',
        //     options: 'portrait, landscape',
        //     inputType: 'text',
        //     vModel: 'pdfOrientation'
        // },

        // {
        // 	label: 'pdf-content-width:',
        // 	type: 'String',
        //     options: 'Any css sizes (e.g. "800px", "65vw", "70%")',
        //     inputType: 'text',
        //     vModel: 'pdfContentWidth'
        // },
        // {
        //   label: "顯示 HK$0:",
        //   type: "Boolean",
        //   options: "true, false",
        //   inputType: "checkbox",
        //   vModel: "showZero",
        // },
        // {
        // 	label: 'show-layout:',
        // 	type: 'Boolean',
        //     options: 'true, false',
        //     inputType: 'checkbox',
        //     vModel: 'showLayout'
        // },
      ],
      isMenuVisible: true
    };
  },
  mounted() {
    const rawFilename = this.refundData.refund_number +
      "(" +
      this.refundData.name_cn + " ["+this.refundData.receipt.receipt_number+"]" +
      ")";
    this.controlValue.filename = sanitizeFilename(rawFilename) + '.pdf';

    this.controlValue.sign_date = this.getDateTime();
  },

  computed: {
    ...mapFields(["controlValue"]),

    isGenerating() {
      return this.progress !== 0 && this.progress !== 100;
    },
    fileName() {
      return this.refundData.refund_number;
    },
  },
  watch: {
    fileName() {
      //console.log('FileName', this.refundData.refund_number)
      const rawFilename = this.refundData.refund_number +
        "(" +
        this.refundData.project_name +
        ")";
      this.controlValue.filename = sanitizeFilename(rawFilename) + '.pdf';
    },
  },

  methods: {
    setInput(e, key, inputType) {
      let value = e.target.value;

      if (inputType === "checkbox") {
        value = e.target.checked;
      }

      if (inputType === "number") {
        value = e.target.value ? parseFloat(e.target.value) : 0;
      }

      this.$set(this.controlValue, key, value);
    },
    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-flatpicker.scss";

</style>